/**
 * Allys Property Location Component
 * 
 * Allys-themed wrapper for PropertyLocation
 */

'use client';

import { PropertyLocation, type PropertyLocationProps } from '@/components/properties';

export function AllysPropertyLocation(props: PropertyLocationProps) {
  return (
    <div 
      className="relative font-inter"
    >
      <PropertyLocation {...props} className="" />
    </div>
  );
}

